import DragableDiv from "components/DragableDiv";
import { isIncludedTab } from "utils/isDesactivatedTab";
import * as S from "./styles";

export type Tab = {
  text: string;
  index: number;
  error?: boolean;
};

type Props = {
  tabs: Tab[];
  invalidTabs?: Tab[];
  deactivatedTabs?: Tab[];
  selectedTab: number;
  onTabClick: (tab: Tab) => void;
};

function TabHeader({
  tabs,
  invalidTabs,
  selectedTab,
  deactivatedTabs,
  onTabClick,
}: Props) {
  function isCurrentTabSelected(tab: Tab) {
    return tab.index === selectedTab;
  }

  return (
    <DragableDiv scrollVisible={true}>
      <S.Wrapper>
        {tabs.map((tab, index) => {
          return (
            <S.Tab
              key={index}
              isActive={isCurrentTabSelected(tab)}
              isDeactivated={isIncludedTab(tab, deactivatedTabs)}
              isInvalid={isIncludedTab(tab, invalidTabs)}
              onClick={() => onTabClick(tab)}
            >
              <span>{tab.text}</span>
            </S.Tab>
          );
        })}
      </S.Wrapper>
    </DragableDiv>
  );
}

export { TabHeader };
